module.exports = __webpack_public_path__ + "assets/img/ja-073d07c5.png";